import styled from "@emotion/styled";
import React, { useState } from "react";
import t from "../../../helper/t";

import imageCloseWhite from "../../../../public/img/icons/close_white.svg";

interface RootDivProps {
  isVisible: boolean;
}

const RootDiv = styled.div<RootDivProps>([
  props => ({
    display: props.isVisible ? "block" : "none"
  }),
  props => props.theme.colors.white,
  props => props.theme.colors.background.red,
  {
    width: "100%",
    zIndex: 1,
    textAlign: "center",

    paddingTop: 16,
    paddingBottom: 16,
  },
]);

const TextDiv = styled.div([
  {
    display: "inline-block",
    padding: "0 35px",
    margin: "0 auto",
  }
]);

const CloseDiv = styled.div([
  {
    position: "absolute",
    right: 20,
    display: "inline-block",
    width: 18,
    height: 18,
  },
  `
  img {
    width: 100%;
    height: 100%;
    vertical-align: -4px;
    cursor: pointer;
  }  
  `
]);

interface VpnStickyProps { }
const VpnSticky: React.FC<VpnStickyProps> = () => {
  const [isVisible, setVisible] = useState(true);

  return (
    <RootDiv isVisible={isVisible}>
      <TextDiv>
        <span>
          <strong>
            {t("Mögliche VPN-Verbindung erkannt")}: {t("Schalt diese für die Dauer des Speedtests aus, um valide Ergebnisse zu erhalten.")}
          </strong>
        </span>
      </TextDiv>
      <CloseDiv>
        <img
          src={imageCloseWhite.src}
          alt="close"
          onClick={() => { setVisible(false) }}
        />
      </CloseDiv>
    </RootDiv>
  );
}

export default VpnSticky;
